import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersInsightPostObjectivesMutateRequestType,
  ResponseMessageType,
} from "~/domains";

type RequestDataType = {
  id: string;
  body: ApiManagersInsightPostObjectivesMutateRequestType;
};

const request = ({ id, body }: RequestDataType) => {
  return new ApiClient()
    .put<ResponseMessageType>(`/api/managers/insight_post_objectives/${id}`, {
      insightPostObjective: body,
    })
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersInsightPostObjectivesUpdate = ({
  options = {},
}: PropsType = {}): UseMutationResult<ResponseMessageType, RequestDataType> => {
  return useMutation(request, { ...options });
};
